import React from 'react'

import { VideoScreen } from '../../components/VideoScreen/VideoScreen'

import srcVideo from './video-05.mp4'
import srcVideoRu from './video-05-ru.webm'
import srcVideoTt from './video-05-tt.webm'
import srcAudioRu from './audio-05-ru.mp3'
import srcAudioTt from './audio-05-tt.mp3'


/* eslint react/prop-types: ["off"] */
export function VideoMap({ isVisible }) {
    return (
        <VideoScreen
            isVisible={isVisible}
            srcVideo={srcVideo}
            srcVideoRu={srcVideoRu}
            srcVideoTt={srcVideoTt}
            srcAudioRu={srcAudioRu}
            srcAudioTt={srcAudioTt}
        />
    )
}
